export const formatToPattern = (value: string, pattern: string): string => {
  const maskLength = [...pattern.matchAll(/#/g)].length
  if (maskLength !== value.length) return value

  let i = 0
  return pattern.replace(/#/g, (): string => {
    i += 1
    return value[i - 1]
  })
}

export const cellphonePattern = (cellphone: string): string =>
  formatToPattern(cellphone, '(##) #####-####')

export const cpfPattern = (cpf: string): string => formatToPattern(cpf, '###.###.###-##')

export const datePattern = (date: string): string =>
  formatToPattern(date.replace(/-/g, ''), '##/##/####')

// TODO: move to Lib Util project
export const currencyMask = (
  inputValue: string | undefined,
  currency: 'BRL' | 'USD' | undefined,
) => {
  if (!inputValue) return ''

  const onlyNumbers = inputValue.replace(/[^\d]/g, '')
  if (!onlyNumbers) return ''

  const padded = onlyNumbers.padStart(3, '0')
  let integerPart = padded.slice(0, -2)
  const decimalPart = padded.slice(-2)

  integerPart = integerPart.replace(/^0+(?!$)/, '') || '0'

  const isUSD = currency === 'USD'
  const thousandSeparator = isUSD ? ',' : '.'
  const decimalSeparator = isUSD ? '.' : ','
  const symbol = isUSD ? 'US$' : 'R$'

  function formatThousandSeparator(num: string, separator: string): string {
    let result = ''
    let count = 0
    for (let i = num.length - 1; i >= 0; i -= 1) {
      result = num[i] + result
      count += 1
      if (count % 3 === 0 && i !== 0) {
        result = separator + result
      }
    }
    return result
  }

  const formattedInteger = formatThousandSeparator(integerPart, thousandSeparator)
  const formattedDecimal = `${decimalSeparator}${decimalPart}`

  return `${symbol}\xa0${formattedInteger}${formattedDecimal}`
}

export function isValidNumber(str: string) {
  const numberRegex = /^-?\d+(\.\d+)?$/
  return numberRegex.test(str)
}
